// Datos del accessToken
export const AccessToken: string = 'accessToken'
